<!--<c-footer>-->
  <div>
    <a href="https://coreui.io/pro/angular/" target="_blank">CoreUI</a>
    <span> &copy; 2023 creativeLabs</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://coreui.io/pro/angular" target="_blank">
      <span> CoreUI for Angular</span>
    </a>
  </div>
<!--</c-footer>-->
